module.exports = __webpack_public_path__ + "static/media/20.fbe52a74.png";